import React, { Fragment, useState } from 'react';
import Modal from 'react-modal';
import { DownloadIcon } from '../../Icons/DownloadIcon';
import PlusIcon from '../../Icons/PlusIcon';
import DocumentIcon from '../../Icons/DocumentIcon';
import Pagination from '../Pagination';
import { translate } from '../../Services/translation';

Modal.setAppElement('body');

const infoModalStyles = {
    content: {
        width: '425px',
        height: '229px',
        margin: 'auto auto',
    },
    overlay: { zIndex: 1000 },
};

const versionsModalStyles = {
    content: {
        width: '708px',
        height: '391px',
        margin: 'auto auto',
    },
    overlay: { zIndex: 1000 },
};

const FilePanel = ({
    header,
    description,
    data,
    language,
    fileId,
    onRemoveFileId,
    languages,
    onPageChange,
    onLanguageChange,
}) => {
    const [info, setInfo] = useState(null);
    const [olderVersions, setOlderVersions] = useState(null);
    return (
        <div className="file-panel-wrapper">
            {!!info && (
                <Modal
                    style={infoModalStyles}
                    isOpen={true}
                    onRequestClose={() => setInfo(null)}
                >
                    <p>{info}</p>
                    <button
                        type="button"
                        className="file-panel-close-modal"
                        onClick={() => setInfo(null)}
                        aria-label={translate('general.close')}
                    >
                        x
                    </button>
                </Modal>
            )}
            {!!olderVersions && (
                <Modal
                    style={versionsModalStyles}
                    isOpen={true}
                    onRequestClose={() => setOlderVersions(null)}
                >
                    <div className="file-panel-versions-wrapper">
                        <button
                            type="button"
                            className="file-panel-close-modal"
                            onClick={() => setOlderVersions(null)}
                            aria-label={translate('general.close')}
                        >
                            x
                        </button>
                        <div className="file-panel-header">
                            <div className="file-panel-header-name">{translate('mediaarchive.name')}</div>
                            <div className="file-panel-header-date">{translate('mediaarchive.date')}</div>
                            <div className="file-panel-header-version">
                                {translate('mediaarchive.version')}
                            </div>
                        </div>
                        {olderVersions.map((v) => (
                            <div className="file-panel-row" key={v.systemId}>
                                {v.info && (
                                    <button
                                        type="button"
                                        className="file-panel-info"
                                        onClick={() => {
                                            setInfo(v.info);
                                        }}
                                        aria-label={translate('general.showinformation')}
                                    >
                                        i
                                    </button>
                                )}
                                <div className="file-panel-name">{v.name}</div>
                                <div className="file-panel-file-name">
                                    <span className="file-panel-file-name-text">
                                        {v.fileName}{' '}
                                    </span>
                                    <span className="file-panel-file-name-details">
                                        ({v.fileType} {v.fileSize})
                                    </span>
                                </div>
                                <div className="file-panel-date">
                                    {v.date !== '0001-01-01' && (
                                        <div className="file-panel-date">
                                            {v.date}
                                        </div>
                                    )}
                                </div>
                                <div className="file-panel-version">
                                    <div className="file-panel-version-number">
                                        {v.version}
                                    </div>
                                </div>
                                <a href={v.url} className="file-panel-download" aria-label={`${translate('general.download')} ${v.name}`}>
                                    <DownloadIcon />
                                </a>
                            </div>
                        ))}
                    </div>
                </Modal>
            )}
            <h2>{header}</h2>
            <p style={{ whiteSpace: 'pre-line' }}>{description}</p>
            <div className="file-panel-buttons">
                <div className="file-panel-buttons-left">
                    <div className="file-panel-buttons-left">
                        {fileId && (
                            <div className="file-panel-pills">
                                {translate('mediaarchive.showing')}:{' '}
                                <span className="file-panel-pill">
                                    {data.files[0].name}{' '}
                                    <button type="button" onClick={onRemoveFileId} aria-label={translate('general.removefilter')}>
                                        <PlusIcon className="file-panel-pill-remove" />
                                    </button>
                                </span>
                            </div>
                        )}
                    </div>
                </div>
                <div className="file-panel-buttons-right">
                    <div className="file-panel-language">
                        <select
                            className="file-panel-language-select"
                            value={language}
                            onChange={onLanguageChange}
                            aria-label={translate('general.selectlanguage')}
                        >
                            {Object.keys(languages).map((id) => (
                                <option key={id} value={id}>
                                    {languages[id]}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
            <div className="file-panel-header">
                <div className="file-panel-header-name">{translate('mediaarchive.name')}</div>
                <div className="file-panel-header-date">{translate('mediaarchive.date')}</div>
                <div className="file-panel-header-version">{translate('mediaarchive.version')}</div>
            </div>
            {data.files.map((f) => (
                <div className="file-panel-row" key={f.systemId}>
                    {f.info && (
                        <button
                            type="button"
                            className="file-panel-info"
                            onClick={() => {
                                setInfo(f.info);
                            }}
                            aria-label={translate('general.showinformation')}
                        >
                            i
                        </button>
                    )}
                    <div className="file-panel-image">
                        <DocumentIcon />
                    </div>
                    <div className="file-panel-name">
                        <a
                            href={f.url.replace(
                                'forceDownload=true',
                                'forceDownload=false'
                            )}
                        >
                            {f.name}
                        </a>
                    </div>
                    <div className="file-panel-file-name">
                        <a
                            href={f.url.replace(
                                'forceDownload=true',
                                'forceDownload=false'
                            )}
                        >
                            <span className="file-panel-file-name-text">
                                {f.fileName}{' '}
                            </span>
                            <span className="file-panel-file-name-details">
                                ({f.fileType} {f.fileSize})
                            </span>
                        </a>
                    </div>
                    <div className="file-panel-date">
                        {f.date !== '0001-01-01' && (
                            <div className="file-panel-date">{f.date}</div>
                        )}
                    </div>
                    <div className="file-panel-version">
                        <div className="file-panel-version-number">
                            {f.version}
                        </div>
                        {!!f.olderVersions.length && (
                            <button
                                type="button"
                                className="file-panel-version-older"
                                onClick={() => {
                                    setOlderVersions(f.olderVersions);
                                }}
                            >
                                {translate('mediaarchive.olderversions')}
                            </button>
                        )}
                    </div>
                    <a href={f.url} className="file-panel-download" aria-label={`${translate('general.download')} ${f.name}`}>
                        <DownloadIcon />
                    </a>
                </div>
            ))}
            <div className="file-panel-paging">
                <Pagination
                    model={{
                        currentPageIndex: data.currentPage,
                        pageCount: data.pageCount,
                        intervalStart: Math.max(data.currentPage - 2, 1),
                        intervalEnd: Math.min(
                            data.currentPage + 2,
                            data.pageCount
                        ),
                        edgeEntries: 1,
                    }}
                    onChange={onPageChange}
                />
            </div>
        </div>
    );
};

export default FilePanel;
